var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-view',{attrs:{"title":"出库审核列表"}},[_c('template',{slot:"action"}),_c('expert-s-table',{ref:"expertSTable",attrs:{"fromType":_vm.ExpertFromType.STOCK_OUT}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }